import { Action, createReducer, on } from "@ngrx/store";
import * as companiesGroupsActions from "./companies-groups.actions";
import { IPagination } from "src/app/shared/models/page.model";
import { GroupsFilterState, ICompaniesGroups } from "../models/companies-groups.model";
import { refillGroupFilter } from 'src/app/shared/utils/helpers';

export interface CompaniesGroupsState {
    companiesGroups: ICompaniesGroups[];
    AllCompaniesGroups: ICompaniesGroups[];
    metadata: IPagination | null;
    companiesGroup: ICompaniesGroups | null;
    loading: boolean;
    groupFilterState: GroupsFilterState;
};

export const initialCompaniesGroupsState: CompaniesGroupsState = {
    companiesGroups: [],
    AllCompaniesGroups: [],
    metadata: null,
    companiesGroup: null,
    loading: false,
    groupFilterState: {
        advanced: refillGroupFilter(),
        keyword: ''
    }
};


const featureReducer = createReducer(
    initialCompaniesGroupsState,
    on(
        companiesGroupsActions.FetchAllCompaniesGroupsSuccess,
        (state, action) => ({
            ...state,
            companiesGroups: action.companiesGroups.data,
            metadata: action.companiesGroups.metadata
        })
    ),
    on(
        companiesGroupsActions.FetchCompaniesGroupsSuccess,
        (state, action) => ({
            ...state,
            AllCompaniesGroups: action.allCompaniesGroups.data,
        })
    ),
    on(companiesGroupsActions.AddCompaniesGroupeSuccess, (state, action) => ({
    ...state,
    AllCompaniesGroups: [...state.AllCompaniesGroups, action.companiesGroup as ICompaniesGroups]
    })),
    on(companiesGroupsActions.SetGroupsLoader, (state, action) => ({
        ...state,
        loading: action.isLoading
    })
    ),
    on(companiesGroupsActions.SetGroupFilter, (state, action) => ({
        ...state,
        groupFilterState: {
            keyword: action.keyword,
            advanced: action.advanced!,
        }
    })),
    on(companiesGroupsActions.SetGroupSearch, (state, action) => ({
        ...state,
        groupFilterState: {
            ...state.groupFilterState,
            searchGroup: action.search,
        }
    })),
    on(companiesGroupsActions.SetSearchGroupLoader, (state, action) => ({
        ...state,
        searchLoading: action.isLoading
    }))
);

export function companiesGroupsReducer(state: CompaniesGroupsState | undefined, action: Action) {
    return featureReducer(state, action);
}